import { Select } from '@evaneos/b2b-ui/legacy';
import cx from 'classnames';
import { useField } from 'formik';
import { FormattedMessage } from 'react-intl';

import { formatCurrenciesForSelectOptions } from '../../../../../resources/contract/operations';
import { MarketCode } from '../../../../../resources/dossier/types';
import { AllTranslationKeys } from '../../../../../shared/intl/types';
import { SidePanelViewMode } from '../../../SidePanel/types';

import s from './ContractFormElements.css';

type Props = {
    wrapperClassName?: string;
    name: string;
    disabled: boolean;
    inputId: string;
    labelTranslationId: AllTranslationKeys;
    dossierMarketCode?: MarketCode;
    onChange?: (value: string) => void;
    viewMode?: SidePanelViewMode;
};

export const SelectCurrency = (props: Props): JSX.Element => {
    const [field, meta, helpers] = useField<string>(props.name);
    const { setValue, setTouched } = helpers;
    const formattedCurrencies = formatCurrenciesForSelectOptions(props.dossierMarketCode);
    const [selectedCurrency] = formattedCurrencies.filter(
        (currency) => currency.value === field.value,
    );

    return (
        <div
            className={props.wrapperClassName}
            {...(props.viewMode && { 'data-contract-view': props.viewMode })}
        >
            <label htmlFor="currency">
                <FormattedMessage id={props.labelTranslationId} />
            </label>
            <div className={s.selectCurrency}>
                <Select
                    {...field}
                    {...props}
                    options={formattedCurrencies}
                    value={selectedCurrency}
                    error={!!meta.error && meta.touched}
                    isDisabled={props.disabled}
                    // @ts-expect-error value may be undefined from react-select onChange callback
                    onChange={({ value }) => {
                        if (props.onChange !== undefined) {
                            return props.onChange(value);
                        }
                        void setValue(value);
                    }}
                    onBlur={() => void setTouched(true, false)}
                />
                {meta.error && meta.touched && (
                    <p className={cx('red', 'annotation')}>
                        <FormattedMessage id="contract.pricing.errors.currency_required" />
                    </p>
                )}
            </div>
        </div>
    );
};
